import { SelectItem } from "primeng/api/selectitem";

export const MachineManufacturerOptionsCycler: SelectItem[] = [
    {label: 'Bio-Rad', value: 'Bio-Rad'},
    {label: 'Agilent', value: 'Agilent'},
    {label: 'LC 480 II', value: 'LC 480 II'}
];

export const MachineManufacturerOptionsExtractor: SelectItem[] = [
    {label: 'Kingfisher', value: 'Kingfisher'},
    {label: 'Tanbead', value: 'Tanbead'}
];

export const MachineManufacturerOptionOther: SelectItem[] = [
    {label: 'Others', value: 'Others'}
];

export const MachineFileTypeOptions: SelectItem[] = [
    {label: 'Bio-Rad', value: 'Bio-Rad'},
    {label: 'Bio-Rad Lims', value: 'Bio-Rad Lims'},
    {label: 'Bio-Rad DK', value: 'Bio-Rad DK'},
    {label: 'LC 480 II', value: 'LC 480 II'},
    {label: 'ABI FLA', value: 'ABI_FLA'},
    {label: 'FastFinder', value: 'Fast Finder'},
    {label: 'AriaDX-xls', value: 'AriaDX-xls'},
    {label: 'AriaDX-txt', value: 'AriaDX-txt'},
    {label: 'QuantStudio5', value: 'QuantStudio5'},
    {label: 'ABI7500', value: 'ABI7500'},
    {label: 'No File', value: 'No File'}
];

export const IOCapacityOptions: SelectItem[] = [
    {label: 'undefined', value: 'undefined'},
    {label: '1*96 to 1*96', value: '1*96 to 1*96'},
    {label: '1*384 to 1*384', value: '1*384 to 1*384'},
    {label: '1*384 to 4*96', value: '1*384 to 4*96'}
];
